import { Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  NavContainer,
  NavArrowContainer,
  NavArrow,
  PageNumber,
} from '@components/DataTable/DataTable.style';
import Dropdown from '@components/Dropdown';
import Icon from '@components/Icon/Icon';

import { PAGE_SIZE_OPTIONS } from './options';

const messages = defineMessages({
  title: {
    id: 'datatable.rowsPerPage',
    defaultMessage: 'Rows per page:',
  },
});
interface CustomFooterProps {
  rowCount: number;
  page: number;
  rowsPerPage: number;
  changeRowsPerPage: (page: string | number) => void;
  changePage: (newPage: number) => void;
}

const CustomFooter = ({
  rowCount,
  page,
  rowsPerPage,
  changePage,
  changeRowsPerPage,
}: CustomFooterProps) => {
  const { formatMessage } = useIntl();

  const pages = Math.ceil(rowCount / rowsPerPage);
  const handlePageChange = (nav: number) => {
    const newPage = page + nav;
    if (newPage < 0 || newPage > pages - 1) {
      return;
    }
    changePage(newPage);
  };

  const handleRowsPerPageChange = (count: string) => {
    const rows = parseInt(count);
    changeRowsPerPage(rows);
  };

  if (rowCount === 0) {
    return null;
  }
  return (
    <tfoot>
      <tr>
        <td>
          <NavContainer>
            <Typography>{formatMessage(messages.title)}</Typography>
            <Dropdown
              height="30px"
              onChange={handleRowsPerPageChange}
              value={rowsPerPage}
              width="min-content"
            >
              {PAGE_SIZE_OPTIONS.map((o) => (
                <option key={`rows-per-page-${o}`} value={o}>
                  {o}
                </option>
              ))}
            </Dropdown>

            <NavArrowContainer>
              <NavArrow onClick={() => handlePageChange(-1)}>
                <Icon
                  clickable
                  color="text.primary"
                  name="chevron-down"
                  rotation={90}
                />
              </NavArrow>
              <PageNumber>{`Page ${page + 1}/${pages}`}</PageNumber>
              <NavArrow onClick={() => handlePageChange(1)}>
                <Icon
                  clickable
                  color="text.primary"
                  name="chevron-down"
                  rotation={-90}
                />
              </NavArrow>
            </NavArrowContainer>
          </NavContainer>
        </td>
      </tr>
    </tfoot>
  );
};

export default CustomFooter;
